import React, { useEffect, useState } from 'react';
import './index.scss';

const FontSizeAdjuster = () => {
  // Estado para o primeiro conjunto de sliders (cor trilogic)
  const [hue, setHue] = useState(() => {
    const savedHue = sessionStorage.getItem('hue');
    return savedHue !== null ? Number(savedHue) : 0;
  });
  
  const [saturation, setSaturation] = useState(43);
  const [lightness, setLightness] = useState(53);

  // Estado para o segundo conjunto de sliders (cor do texto)
  const [textHue, setTextHue] = useState(0);
  const [textSaturation, setTextSaturation] = useState(0);
  const [textLightness, setTextLightness] = useState(0);

  // Estado para o terceiro conjunto de sliders (cor de fundo)
  const [bgHue, setBgHue] = useState(0);
  const [bgSaturation, setBgSaturation] = useState(0);
  const [bgLightness, setBgLightness] = useState(100);
  
  // Funções para atualizar o estado dos sliders
  const handleHueChange = (event) => setHue(event.target.value);
  const handleSaturationChange = (event) => setSaturation(event.target.value);
  const handleLightnessChange = (event) => setLightness(event.target.value);
  const handleTextHueChange = (event) => setTextHue(event.target.value);
  const handleTextSaturationChange = (event) => setTextSaturation(event.target.value);
  const handleTextLightnessChange = (event) => setTextLightness(event.target.value);
  const handleBgHueChange = (event) => setBgHue(event.target.value);
  const handleBgSaturationChange = (event) => setBgSaturation(event.target.value);
  const handleBgLightnessChange = (event) => setBgLightness(event.target.value);

  const darkTextLightness = Math.max(0, textLightness - 5);

  useEffect(() => {
    sessionStorage.setItem('hue', String(hue));
  }, [hue]);

  useEffect(() => {
    document.documentElement.style.setProperty('--cor-trilogic', `hsl(${hue}, ${saturation}%, ${lightness}%)`);
    document.documentElement.style.setProperty('--text-color', `hsl(${textHue}, ${textSaturation}%, ${textLightness}%)`);
    document.documentElement.style.setProperty('--color-bg-side', `hsl(${bgHue}, ${bgSaturation}%, ${bgLightness}%)`);
    document.documentElement.style.setProperty('--text-color-dark', `hsl(${textHue}, ${textSaturation}%, ${darkTextLightness}%)`);
  }, [hue, saturation, lightness, textHue, textSaturation, textLightness, bgHue, bgSaturation, bgLightness]);

  return (
  <div className="superContainerBrabo">
    <div className="MenuTrocaCor-groups">
      <div className="MenuTrocaCor-group">
        <h6>Cor Trilogic</h6>
        <p>Ajustar Matiz: {hue}</p>
        <input type="range" min="0" max="360" value={hue} onChange={handleHueChange} aria-label="Ajustar Matiz Trilogic" />
        <p>Ajustar Saturação: {saturation}%</p>
        <input type="range" min="0" max="100" value={saturation} onChange={handleSaturationChange} aria-label="Ajustar Saturação Trilogic" />
        <p>Ajustar Luminosidade: {lightness}%</p>
        <input type="range" min="0" max="100" value={lightness} onChange={handleLightnessChange} aria-label="Ajustar Luminosidade Matiz" />
      </div>
      <div className="MenuTrocaCor-group">
        <h6>Cor do Texto</h6>
        <p>Ajustar Matiz: {textHue}</p>
        <input type="range" min="0" max="360" value={textHue} onChange={handleTextHueChange} aria-label="Ajustar Matiz Texto" />
        <p>Ajustar Saturação: {textSaturation}%</p>
        <input type="range" min="0" max="100" value={textSaturation} onChange={handleTextSaturationChange} aria-label="Ajustar Saturação Texto" />
        <p>Ajustar Luminosidade: {textLightness}%</p>
        <input type="range" min="0" max="100" value={textLightness} onChange={handleTextLightnessChange} aria-label="Ajustar Luminosidade Texto" />
      </div>
      <div className="MenuTrocaCor-group">
        <h6>Cor de Fundo</h6>
        <p>Ajustar Matiz : {bgHue}</p>
        <input type="range" min="0" max="360" value={bgHue} onChange={handleBgHueChange} aria-label="Ajustar Matiz " />
        <p>Ajustar Saturação : {bgSaturation}%</p>
        <input type="range" min="0" max="100" value={bgSaturation} onChange={handleBgSaturationChange} aria-label="Ajustar Saturação " />
        <p>Ajustar Luminosidade : {bgLightness}%</p>
        <input type="range" min="0" max="100" value={bgLightness} onChange={handleBgLightnessChange} aria-label="Ajustar Luminosidade Fundo" />
      </div>
    </div>
  </div>
);
};

export default FontSizeAdjuster;
